import { Icon, Box, Text } from '@bonanza-social/moonlight';
import { FOOTER_LINKS } from './FooterLinks.constants';
import FooterLink from '../FooterLink/FooterLink';
import LanguageSwitcher from '../../LanguageSwitcher/LanguageSwitcher';

function FooterLinks() {
  return (
    <Box width="100%" justifyContent="center">
      <Box
        width="100%"
        maxWidth={{ desktop: '100%', tablet: '100%', mobile: '100%' }}
        flex={1}
        flexDirection="column"
        alignItems="center"
        gap={{
          desktop: 'space-600',
          tablet: 'space-400',
          mobile: 'space-1000',
        }}
      >
        <Box
          width="100%"
          flexDirection="row"
          justifyContent="center"
          alignItems="center"
          gap="space-400"
          marginBottom={{
            desktop: 'space-400',
            tablet: 'space-200',
            mobile: 'space-0',
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="100%"
          >
            <Icon
              name="BonanzaLogo"
              width={{ desktop: 218, tablet: 155, mobile: 155 }}
              height={{ desktop: 56, tablet: 40, mobile: 40 }}
            />
          </Box>
        </Box>

        <Box
          width={{ desktop: 'auto', tablet: '100%', mobile: '100%' }}
          flex={{ desktop: 0, tablet: 2, mobile: 2 }}
          flexDirection={{ desktop: 'row', tablet: 'column', mobile: 'column' }}
          gap={{ desktop: 'space-1000', tablet: 'space-0', mobile: 'space-0' }}
          flexWrap={{ desktop: 'nowrap', tablet: 'wrap', mobile: 'wrap' }}
          alignItems={{
            desktop: 'flex-start',
            tablet: 'center',
            mobile: 'center',
          }}
          justifyContent={{
            desktop: 'flex-start',
            tablet: 'center',
            mobile: 'center',
          }}
          marginBottom={{
            desktop: 'space-800',
            tablet: 'space-600',
          }}
        >
          {FOOTER_LINKS.map((link, index) => (
            <FooterLink {...link} key={index} />
          ))}
        </Box>
      </Box>

      <Box
        width={{ desktop: '100%', tablet: '100%', mobile: '100%' }}
        borderTopWidth="border-width-025"
        borderColor="borderSecondary"
        paddingTop="space-600"
        gap={'space-500'}
      >
        <LanguageSwitcher />

        <Text
          textAlign="center"
          color="darkSurfacePrimary"
          opacity={0.7}
          locNS="common"
          locKey="footerDisclaimer"
          paddingTop={'space-400'}
        />
      </Box>
    </Box>
  );
}

export default FooterLinks;
